import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHackhandsComponent } from './simple-icons-hackhands.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHackhandsComponent ],
    exports:      [ SimpleIconsHackhandsComponent ],
    bootstrap:    []
})
export class SimpleIconsHackhandsModule {}
